import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { getParentHierarchy } from 'src/@smartmanufacturing/common/custom_methods';
import { Multilingual } from 'src/app/services/multilingual';
import { TranslaterService } from 'src/app/services/translater.service';
import { BaseApi } from 'src/backend/api/base-api';

@Component({
  selector: 'app-bread-crumb',
  templateUrl: './bread-crumb.component.html',
  styleUrls: ['./bread-crumb.component.scss']
})
export class BreadCrumbComponent implements OnInit {

  breadcrumList: any[] = [];
  menus: any[] = [];
  currentMenuId: string = '';
  langObj: any;
  pageId: string;
  moduleId: any;
  ParameterTypeGripApi: any;
  HeaderGripApi: any;
  lang: Multilingual;
  languageDir: string;
  constructor(private baseApi: BaseApi, public router: Router, public translate: TranslateService, public translater: TranslaterService) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => { event.lang === 'ar' ? this.languageDir = 'rtl' : this.languageDir = 'ltr'; this.getLangWords(); });
  }

  ngOnInit() {
    // languageDir was declared and set by onLangChange but never bound to
    // anything, so the breadcrumb only inherited direction from whatever page
    // hosted it - and stayed LTR on pages whose wrapper has no dir attribute.
    this.languageDir = this.translate.currentLang === 'ar' ? 'rtl' : 'ltr';
    this.menus = this.baseApi.getMenuCardsSession();
    this.currentMenuId = this.baseApi.getCurrentMenuID();
    this.getBreadcrumList();
  }

  getTransalatedValue(value: string): string {
    if (!value) {
      return '';
    }
    const fromFiles = this.fromI18nFiles(value);
    const fromDb = this.langObj && this.langObj[value] ? this.langObj[value] : null;
    // A database tag whose value is still the English label is not a translation, so prefer the i18n file over it.
    if (fromDb) {
      if (fromFiles && this.isUntranslated(fromDb, value)) {
        return fromFiles;
      }
      return fromDb;
    }
    // never render an empty breadcrumb - fall back to the raw label
    return fromFiles || value;
  }

  /**
   * True when the database gave us back something that cannot be a translation:
   * either the English label again (ignoring case and stray spaces - several tags
   * carry a trailing one), or, for Arabic, a value with no Arabic letters in it.
   * English is never treated this way, since there the label IS the translation.
   */
  private isUntranslated(fromDb: string, label: string): boolean {
    const lang = this.translate.currentLang;
    if (!lang || lang === 'en') {
      return false;
    }
    const normalise = (text: string) => text.replace(/\s+/g, ' ').trim().toLowerCase();
    if (normalise(fromDb) === normalise(label)) {
      return true;
    }
    return lang === 'ar' && !/[\u0600-\u06FF]/.test(fromDb);
  }

  /**
   * Menu labels come from the menu API, not from a file in this repo, so their
   * spacing, punctuation and casing drift from the key names
   * ("NEW 5S & Gemba DashBoard" vs "newfivesgembadashboard"). Try the label as
   * written, then without spaces, then a canonical form - lower case, letters
   * and digits only - which is how these keys are written in the JSON files.
   */
  private fromI18nFiles(value: string): string | null {
    const candidates = [
      value,
      value.replace(/\s+/g, ''),
      value.toLowerCase().replace(/[^a-z0-9]/g, ''),
    ];
    for (const candidate of candidates) {
      const translated = this.translate.instant(candidate);
      if (typeof translated === 'string' && translated !== candidate) {
        return translated;
      }
      // a label naming a whole page section resolves to an object, not a string
      if (translated && typeof translated === 'object' && typeof translated.title === 'string') {
        return translated.title;
      }
    }
    return null;
  }

  public getLangWords() {
    const key = {
      ModuleId: 0,
      PageId: 0,
      LanguageId:
        this.translate.currentLang === 'en'
          ? 1
          : this.translate.currentLang === 'ar'
            ? 2
            : this.translate.currentLang === 'fr'
              ? 3
              : this.translate.currentLang === 'sp'
                ? 4
                : this.translate.currentLang === 'gr'
                  ? 5
                  : this.translate.currentLang === 'du'
                    ? 6
                    : 1,
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
      this.lang = new Multilingual(this.translater, this.translate);
      this.lang.getLangWords();
    });
  }

  getBreadcrumList(): any {
    const menusForBreadCrumbs = getParentHierarchy(this.menus, this.currentMenuId)
    this.breadcrumList = [...menusForBreadCrumbs];
    this.getLangWords();
  }



  displayRightmenu(menuId: string, url: any, type: string): any {
    this.baseApi.saveCurrentMenuID(menuId);
    switch (type) {
      case 'subheading':
        this.router
          .navigateByUrl('/', { skipLocationChange: true })
          .then(() => this.router.navigate(['Home']));
        break;
      case 'dropdown':
        this.router
          .navigateByUrl('/', { skipLocationChange: true })
          .then(() => this.router.navigate(['Home']));
        break;
      case 'link':
        if (url.indexOf('/Home/ExternalLink?link=') > -1) {
          url = url.replace('/Home/ExternalLink?link=', '');
          window.open(url, '_blank');
        }
        this.router
          .navigateByUrl('/', { skipLocationChange: true })
          .then(() => this.router.navigate([url]));
        break;
      default:
        this.router
          .navigateByUrl('/', { skipLocationChange: true })
          .then(() => this.router.navigate(['Home']));
        break;
    }
  }

}
